import MAX_SCORE from "~/constants/review/MAX_SCORE";
import MIN_SCORE from "~/constants/review/MIN_SCORE";
import ReviewCommentAuthor from "~/models/reviewComment/ReviewCommentAuthor";
import isPresent from "~/kernel/validation/isPresent";
import type SerializeType from "~/kernel/server/SerializeType";
import type {
  CompanyPageReview,
  CompanyPageReviewComment,
} from "./CompanyPageReview";

type SerializedReview = SerializeType<CompanyPageReview>;
type SerializedComment = SerializeType<CompanyPageReviewComment>;

export function buildReviewMetadata(review: SerializedReview) {
  return {
    "@type": "Review",
    ...authorMetadata(review.reviewerName, ReviewCommentAuthor.User),
    datePublished: review.createdAt,
    reviewBody: review.reviewText,
    reviewRating: {
      "@type": "Rating",
      ratingValue: review.score,
      bestRating: MAX_SCORE,
      worstRating: MIN_SCORE,
    },
    ...commentsMetadata(review.comments),
  };
}

function commentsMetadata(comments: SerializedComment[]) {
  if (comments.length < 1) {
    return {};
  }

  return {
    commentCount: comments.length,
    comment: comments.map(buildCommentMetadata),
  };
}

function buildCommentMetadata(comment: SerializedComment) {
  return {
    "@type": "Comment",
    ...authorMetadata(comment.authorName, comment.author),
    dateCreated: comment.createdAt,
    text: comment.content,
  };
}

function authorMetadata(name: string | null, author: ReviewCommentAuthor) {
  if (!isPresent(name)) {
    return {};
  }

  return {
    author: {
      "@type":
        author === ReviewCommentAuthor.Company ? "Organization" : "Person",
      name,
    },
  };
}
